import { render, staticRenderFns } from "./GlobalLinkForm.vue?vue&type=template&id=c982434c&scoped=true&"
import script from "./GlobalLinkForm.vue?vue&type=script&lang=js&"
export * from "./GlobalLinkForm.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLinkForm.vue?vue&type=style&index=0&id=c982434c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c982434c",
  null
  
)

export default component.exports